import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import { data_center_eu, StatGetDeviceId } from 'eco-design-micro/EcoStat/config';

export interface errorMonitoringParamsProps {
    /**
     * 错误类型 1(必填1)
     *
     * content-empty 配置化为空
     *
     * user-error 用户操作失败
     *
     * product-error 产品信息有误
     *
     * other-error 其它错误
     */
    error_type_1: 'content-empty' | 'user-error' | 'product-error' | 'other-error';
    /**
     * 错误类型 2
     */
    error_type_2?: string;
    /**
     * 错误页面中位置 1
     */
    error_position_1?: string;
    /**
     * 错误页面中位置 2
     */
    error_position_2?: string;
    /**
     * 错误内容 1
     */
    error_content_1?: string;
    /**
     * 错误内容 2
     */
    error_content_2?: string;
    /**
     * 错误内容 3
     */
    error_content_3?: string;
    /**
     * 错误内容 4
     */
    error_content_4?: string;
}
export interface errorMonitoringOptionsProps {
    className?: string;
}
// 需要过滤的code 1000 2026 1003
const filterCode = ['1000', '2026', '1003'];
const STAT_CONFIG_BASE_URL_EU = process?.env?.NEXT_PUBLIC_BH_HOST || 'https://api-burying-point.ecoflow.com';
const STAT_CONFIG_BASE_URL_NA = process?.env?.NEXT_PUBLIC_BH_HOST_NA || 'https://api-burying-point-us.ecoflow.com';
export const sendPostErrorMonitoring = async (locale: string, params: errorMonitoringParamsProps, options?: errorMonitoringOptionsProps) => {
    if (typeof window === 'undefined') {
        return null;
    }
    // 过滤部分error code
    if (params.error_content_1 === 'user-error' && filterCode.includes(params.error_content_1)) return;

    const pageHref = location.href;
    const formData = new URLSearchParams();
    formData.append('page_href', pageHref); //页面路径
    const device_id = await StatGetDeviceId({});
    formData.append('device_id', device_id); //ID1
    const localeItem = getDefaultHeader(locale);
    formData.append('app_id', localeItem['x-appid']); //站点
    for (const keyA in params) {
        const valueA: any = params[keyA];
        formData.append(keyA, valueA);
    }

    let baseUrl = STAT_CONFIG_BASE_URL_NA;
    if (data_center_eu.includes(locale)) {
        baseUrl = STAT_CONFIG_BASE_URL_EU;
    }
    navigator.sendBeacon(`${baseUrl}/web/error-monitoring-page-common/create`, formData);
};

export const sendPostErrorClient = async (locale: string, params: any, options?: errorMonitoringOptionsProps) => {
    if (typeof window === 'undefined') {
        return null;
    }
    const pageHref = location.href;
    const formData = new URLSearchParams();
    formData.append('page_href', pageHref); //页面路径
    const device_id = await StatGetDeviceId({});
    formData.append('device_id', device_id); //ID1
    const localeItem = getDefaultHeader(locale);
    formData.append('app_id', localeItem['x-appid']); //站点
    for (const keyA in params) {
        const valueA: any = params[keyA];
        formData.append(keyA, valueA);
    }

    let baseUrl = STAT_CONFIG_BASE_URL_NA;
    if (data_center_eu.includes(locale)) {
        baseUrl = STAT_CONFIG_BASE_URL_EU;
    }
    // navigator.sendBeacon(`${baseUrl}/web/error-monitoring-page-client/create`, formData);
};
